import type { CustomerThreadKind } from '../components/threadLabels';

/** The conversation list a page was opened from; a conversation page carries it back. */
export interface MessagesListSearch {
  /** The conversations listed; open when absent. */
  show?: 'resolved';
  /** A ticket reference ("GC-1042") or words in the subject; searches open and resolved. */
  q?: string;
}

/** What a new message is prefilled with. */
export interface NewMessageSearch {
  kind?: CustomerThreadKind;
  subject?: string;
  /** The deployment a new message is about. */
  environmentId?: string;
}

/**
 * /messages also takes a conversation (`thread`, the link conversation emails
 * carry) and the prefill of a new message; both redirect to their own page.
 */
export type MessagesSearch = MessagesListSearch & NewMessageSearch & { thread?: string };

const kinds = new Set<string>(['question', 'renewal', 'license', 'bug', 'feature', 'crash']);

export const parseListSearch = (s: Record<string, unknown>): MessagesListSearch => ({
  show: s.show === 'resolved' ? 'resolved' : undefined,
  q: typeof s.q === 'string' && s.q.trim() ? [...s.q.trim()].slice(0, 100).join('') : undefined,
});

export const parseNewMessageSearch = (s: Record<string, unknown>): NewMessageSearch => ({
  kind:
    typeof s.kind === 'string' && kinds.has(s.kind) ? (s.kind as CustomerThreadKind) : undefined,
  subject:
    typeof s.subject === 'string' && s.subject ? [...s.subject].slice(0, 200).join('') : undefined,
  environmentId:
    typeof s.environmentId === 'string' && s.environmentId ? s.environmentId : undefined,
});

export const parseMessagesSearch = (s: Record<string, unknown>): MessagesSearch => ({
  thread: typeof s.thread === 'string' && s.thread ? s.thread : undefined,
  ...parseNewMessageSearch(s),
  ...parseListSearch(s),
});
